import i18n from "@/i18n";

/**
 * Format a price with the currently active locale.
 * FR: 19,00 €     NL: € 19,00     EN: €19.00     DE: 19,00 €
 */
export function formatPrice(amount, currency = "EUR") {
  const lang = (i18n.language || "fr").slice(0, 2);
  const localeMap = { fr: "fr-BE", nl: "nl-BE", en: "en-GB", de: "de-BE" };
  const locale = localeMap[lang] || "fr-BE";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount) || 0);
  } catch {
    return `€${Number(amount).toFixed(2)}`;
  }
}
